import React, { createContext, useEffect, useState } from 'react'
import localStorageService from '../services/localStorage'

export const UserContext = createContext()

export const UserProvider = (props) => {
  const [userData, setUserData] = useState(localStorageService.get())
  useEffect(() => {
    if (!userData) {
      setUserData(localStorageService.get())
    } else {
      const { userGuarantee, ...restUserData } = userData
      localStorageService.set(restUserData)
    }
  }, [userData])

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {props.children}
    </UserContext.Provider>
  )
}
